<div class="header">
  <div class="label orders" data-automation-e2e-selector="ordersCount">
    <span
      [textContent]="(orders | async) || ''"
      data-automation-e2e-selector="value"
    ></span>
    <span data-automation-e2e-selector="label">Orders</span>
  </div>
  <div class="label total" data-automation-e2e-selector="ordersAmount">
    <span
      [textContent]="(total | async) || ''"
      data-automation-e2e-selector="value"
    ></span>
    <span data-automation-e2e-selector="label">Total (M)</span>
  </div>
</div>
<div class="chart">
  <muni-gameday-order-summary-bar-chart
    [bars]="bars | async"
    data-automation-e2e-selector="orderSummaryBarChart"
  >
  </muni-gameday-order-summary-bar-chart>
</div>
